module.exports = __webpack_public_path__ + "img/warn.191c1a73.png";